// extracted by mini-css-extract-plugin
module.exports = {"body":"Circulo_body__39WVK","circulo":"Circulo_circulo__3aVd7"};